<template>
  <div class="dispatcher-panel-job-new">
    <div
      v-if="transaction"
      class="bottom-wrapper"
      :class="{ 'is-retry': isRetry }"
    >
      <button class="button is-white has-text-link share-btn">
        <i class="fa fa-share-alt fa-lg" @click="shareRideRequest" />
      </button>
      <!-- <div v-if="isDispatch" class="subtitle is-5 has-text-left">
        <i class="fa fa-kiwi-bird fa-sm has-text-orange" />
        {{ $t("driver.special-dispatch") }}
      </div> -->
      <div class="subtitle is-5 has-text-left">
        <span v-if="isDelivery">
          <i class="fa fa-box-open fa-sm" />
          {{ $t("delivery.new-delivery") }}&nbsp;
        </span>
        <span v-else>
          <i class="fa fa-user fa-sm" />
          {{ $t("driver.new-passenger") }}&nbsp;
        </span>
        <span
          class="notification is-warning has-text-weight-medium pickup-dist"
          @click="showDistanceHint"
          >{{ distanceToPickupKM }}</span
        >
        &nbsp;
        <span class="circle" v-if="newTransactionsCount > 1">
          &nbsp;{{ newTransactionsCount }}&nbsp;
        </span>
      </div>

      <div v-if="scheduledTime(t)">
        <span class="tag is-medium has-text-link scheduled">
          {{ $t("driver.scheduled-pickup-time") }}
          {{ scheduledTime(t) }} ({{ humanTime(t) }})
        </span>
      </div>

      <div class="buttons is-centered">
        <!-- Dispatch -->
        <button
          v-if="dispatchTo"
          class="button is-primary is-rounded is-large accept-btn"
          :disabled="editing"
          @click="dispatch"
        >
          {{ $t("driver.dispatch") }}
        </button>
        <button
          v-else
          class="button has-text-success is-rounded is-large accept-btn"
          @click="setDriverHint"
        >
          Set Driver
          <!-- &nbsp;<i class="fa fa-arrow-down" /> -->
        </button>
        <button
          class="button is-rounded is-large reject-btn has-text-danger"
          :disabled="editing"
          @click="reject"
        >
          {{ $t("driver.reject") }}
        </button>
      </div>

      <!-- <div class="field is-grouped" style="margin: 10px"> -->
      <div class="control has-icons-left" style="margin: 10px">
        <div class="select is-medium is-success is-fullwidth">
          <select @change="selectDriver($event)">
            <option disabled selected value>
              -- {{ $t("driver.select-driver") }} --
            </option>
            <option v-for="d in drivers" :value="d.value" :key="d.key">
              {{ d.key }}
            </option>
          </select>
          <span class="icon is-small is-left">
            <i class="fas fa-shuttle-van"></i>
          </span>
        </div>
      </div>
      <!-- <div class="control">
          <input
            class="input is-medium is-success"
            v-model="eta"
            type="number"
            placeholder="⏱ETA"
          />
        </div> -->
      <!-- </div> -->

      <div class="card" :style="cardColor(transaction)">
        <div class="card-content">
          <p
            v-if="t.data.ref"
            class="single-line no-scrollbar"
            style="text-align: left; width: 100%; margin-bottom: 6px"
          >
            <span class="order-no">
              <i class="fa fa-receipt fa-sm has-text-grey" />
              &nbsp;#{{ t.data.ref }}
            </span>
            <span class="shop-name">
              <i class="fa fa-store-alt fa-sm" />
              <span class="link">{{ pickupName }}</span>
            </span>
          </p>
          <div class="media">
            <div class="media-left">
              <img class="profile-pic" :src="customerPic" />
            </div>
            <div class="media-content no-scrollbar">
              <p class="is-size-5">
                <span class="single-line">
                  <i class="fa fa-user fa-sm" />
                  <span v-if="t.data.pax" class="pax-cnt"
                    >x{{ t.data.pax }}</span
                  >
                  <span>{{ customerName }}</span>

                  <!-- USER TAGS -->
                  <span class="user-tags">
                    <span v-if="unitNumber" class="tag is-grey is-medium">{{
                      unitNumber
                    }}</span>
                    <!-- <span
                      v-if="t.data.ref"
                      class="tag is-dark is-medium"
                      @click="viewOrderDetails"
                    >
                      <i class="fa fa-receipt" style="margin-right: 4px" />
                      {{ t.data.ref }}
                    </span> -->
                  </span>
                </span>
              </p>

              <p class="fare-wrapper">
                <span v-if="isLalamove">
                  <span class="fare is-size-5" style="background-color: #eee">
                    ฿{{ t.data.fare.price }}
                  </span>
                  <span class="fare is-size-5">
                    <img src="../assets/tukpay.png" class="tukpay-logo" />
                  </span>
                </span>
                <span v-else>
                  <span class="fare is-size-5" style="background-color: #eee">
                    <span v-if="t.data.fare">฿{{ t.data.fare.price }}</span>
                    <span v-else class="has-text-success">FREE</span>
                  </span>
                  <span v-if="cash" class="fare has-text-grey is-size-5">
                    {{ $t("cash") }}
                  </span>
                  <span v-if="tukpay">
                    <img src="../assets/tukpay.png" class="tukpay-logo" />
                  </span>
                </span>
              </p>
            </div>
          </div>

          <div v-if="isDelivery" style="text-align: left">
            <p
              v-if="paymentRequired"
              class="is-medium"
              style="
                background-color: #cff;
                padding: 4px 8px;
                border-radius: 3px;
                box-shadow: 0 0 3px #aaa;
              "
            >
              <span v-html="payShopX"></span>
              <br />
              <span v-html="collectFromCustomerX"></span>
              <span
                v-if="cashback"
                class="has-text-danger has-text-weight-bold"
              >
                <br />
                <span v-html="giveCashbackX"></span>
              </span>
            </p>
            <p
              v-else
              class="has-text-dark is-medium"
              style="
                background-color: lightgreen;
                padding: 8px;
                border-radius: 5px;
              "
            >
              {{ $t("delivery.already-paid-for") }}
            </p>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-content has-text-left">
          <p style="font-size: 1.3em">
            <i class="fa fa-map-marker-alt has-text-primary" />
            &nbsp;{{ $t("driver.pickup-at") }}
            <a :href="googleMap" target="_blank" class="has-text-link">
              <!-- {{ t.data.pickup_stop.name || $t("ride.pin-location") }} -->
              {{ pickupName }}
              <!-- <i class="fa fa-location-arrow" /> -->
            </a>
          </p>
          <p v-if="transaction.data.dropoff_stop" @click="showDropoff">
            <i class="fa fa-ellipsis-h" />&nbsp;
            <i class="fa fa-map-marker-alt has-text-link" />&nbsp;
            <!-- <span v-if="!isShowDropoff" class="link">{{ tripDistance }}</span>
            <span v-else>
              {{ $t("driver.dropoff-at") }}
              <a :href="directionsURL" target="_blank">
                {{ dropoffName }}
              </a>
            </span> -->

            <span v-if="isShowDropoff || !tripDistance">
              {{ $t("driver.dropoff-at") }}
              <a :href="directionsURL" target="_blank">
                {{ dropoffName }}
              </a>
            </span>
            <span v-else class="link">{{ tripDistance }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import geo from "@/geo";

export default {
  name: "DispatcherPanelJobNew",
  props: {
    transactions: {
      type: Array,
    },
  },
  data() {
    return {
      editing: false,
      requests: 1,
      drivers: [],
      dispatchTo: null, // driver to dispatch to
      eta: null, // if ETA is set
      isShowDropoff: false,
      timer: 0,
    };
  },
  computed: {
    transaction() {
      if (!this.transactions) return null;
      return this.transactions[0];
    },
    t() {
      if (!this.transactions) return null;
      return this.transactions[0];
    },
    dispatcherRole() {
      return this.$store.getters.isDispatcher;
    },
    workflowID() {
      return this.dispatcherRole.workflow_id;
    },
    pickupName() {
      if (!this.t.data.pickup_stop.name) return this.$t("ride.pin-location");
      return this.shortenString(this.t.data.pickup_stop.name, 40);
    },
    dropoffName() {
      if (!this.t.data.dropoff_stop.name) return this.$t("ride.pin-location");
      return this.shortenString(this.t.data.dropoff_stop.name, 40);
    },
    showCountdownTimer() {
      if (this.isDelivery) return true; // just express delivery with scheduled time soon
      var countdownWorkflows = ["Public Tuk Tuk", "Motocy"];
      return countdownWorkflows.includes(this.t.workflow_type_name);
    },
    isRetry() {
      return this.t.data.retry;
    },
    newTransactionsCount() {
      return this.$store.getters.getWorkerTransactionsStateNew.length;
    },
    payShopX() {
      var orderValue = this.t.data.delivery.order_value;
      var amount = `<strong>${this.symbol}${orderValue}</strong>`;
      return this.$t("delivery.pay-shop-x", { x: amount });
    },
    collectFromCustomerX() {
      var amount = `<strong>${this.symbol}${this.driverCollectValue}</strong>`;
      return this.$t("delivery.collect-from-customer-x", { x: amount });
    },
    giveCashbackX() {
      var amount = `<strong>${this.symbol}${this.cashback}</strong>`;
      // return this.$t("delivery.give-cashback-x", { x: amount });
      return this.$t("delivery.get-bonus-x", { x: amount });
    },
    isTaxi() {
      return this.t.workflow_type_name === "Taxi";
    },
    customerName() {
      if (!this.t) return null;
      return this.t.customer.name || this.t.customer.phone_number;
      // if (this.t.customer.name === "") {
      //   return this.t.customer.phone_number;
      // }
      // return this.shortenString(this.t.customer.name, 15);
    },
    googleMap() {
      var lat = this.t.data.pickup_stop.lat;
      var lon = this.t.data.pickup_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    directionsURL() {
      if (!this.t.data.pickup_stop) return;
      if (!this.t.data.dropoff_stop) return;
      // var current = this.$store.state.userState;
      var scoords = `${this.t.data.pickup_stop.lat},${this.t.data.pickup_stop.lon}`;
      var dcoords = `${this.t.data.dropoff_stop.lat},${this.t.data.dropoff_stop.lon}`;
      return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`; //url + coords;
    },
    distanceToPickupMeters() {
      var coords = this.$store.getters.getUserLocation;
      var userLoc = { lat: coords[0], lon: coords[1] };
      return geo.distanceToUserInMeters(this.t.data.pickup_stop, userLoc);
    },
    distanceToPickupKM() {
      var dist = this.distanceToPickupMeters;
      var km = (dist / 1000).toFixed(1);
      return `${km} km`;
    },
    distanceToPickup() {
      var dist = this.distanceToPickupMeters;
      var km = (dist / 1000).toFixed(1);
      return `${km} ${this.$t("driver.distance-to-pickup")}`; //`${km} km to this pickup`;
    },
    tripDistance() {
      if (!this.t.data.fare) return; // private tuk tuk dropoff won't have fare
      if (!this.t.data.fare.distance) return;
      var km = (this.t.data.fare.distance / 1000).toFixed(1);
      return `${km} ${this.$t("driver.km-journey")}`;
    },
    // drivers() {
    //   if (this.$store.state.workflowDrivers) {
    //     return this.$store.state.workflowDrivers;
    //   }
    //   return [];
    // },
    unitNumber() {
      if (!this.transactions) return null;
      var t = this.transactions[0];
      if (!t.customer.role) return null;
      if (!t.customer.role.data) return null;
      if (!t.customer.role.data.unit_number) return null;
      return `Unit ${t.customer.role.data.unit_number}`;
    },
    businessPic() {
      var placeholder = this.$store.state.menuItemPlaceholderPic; // change to a shop cartoon?
      if (!this.t.business) return placeholder;
      return this.t.business.profile_pic_url || placeholder;
    },
    customerPic() {
      if (this.t.data.type === "delivery") {
        return this.businessPic;
      }
      return this.t.customer.profile_pic_url || this.fallbackProfPic();
    },
    fareType() {
      return this.transaction.data.price;
    },
    prettyFare() {
      return this.transaction.data.price;
    },
    isTukPay() {
      if (this.transaction.data.payment_method === "tukpay") return true;
      return false;
    },
    cash() {
      if (!this.t.data.fare) return false;
      if (this.t.data.fare.cash !== 0) return true; // there is a cash component
      return false;
    },
    tukpay() {
      if (!this.t.data.fare) return false;
      if (this.t.data.fare.tukpay !== 0) return true; // there is a tukpay component
      return false;
    },
    // isDispatch() {
    //   return this.t.handled_by;
    // },
    isDelivery() {
      return this.t.data.type === "delivery";
    },
    orderValue() {
      return this.t.data.delivery.order_value;
    },
    paymentRequired() {
      if (!this.isDelivery) return false;
      if (!this.orderValue) return false;
      var arr = ["cash", "promptpay", "bank-transfer"];
      return arr.includes(this.t.data.delivery.payment_method);
      // if (this.t.data.delivery.payment_method === "cash") return true;
      // return false;
    },
    isLalamove() {
      if (!this.t.data.delivery) return null;
      return this.t.data.delivery.lalamove;
      // return this.t.data.lalamove_order_id;
    },
    driverCollectValue() {
      if (this.isLalamove) return this.orderValue;
      var sum = parseInt(this.orderValue) + parseInt(this.t.data.fare.cash);
      if (this.cashback) return sum - this.cashback;
      return sum;
    },
    cashback() {
      return this.t.data.delivery.cashback;
    },
    symbol() {
      return this.currencySymbol(this.t.business.country);
    },
  },
  // activated() {},
  mounted() {
    setInterval(() => (this.timer += 1), 1000);
    this.getDrivers();
  },
  methods: {
    setDriverHint() {
      // this.$refs.select.click();
      var msg = `<div style='text-align:left'>
      Dispatch to a specific driver<br>or wait for any driver to accept the job</div>`;
      this.infoToast(msg, "top", 8000);
    },
    showDistanceHint() {
      this.infoToast(this.distanceToPickup);
    },
    cardColor(t) {
      var age = (new Date() - new Date(t.created_at)) / 1000;
      if (age > 60 && age < 120) return "background-color: gold";
      if (age > 120) return "background-color: pink";
    },
    showDropoff() {
      this.isShowDropoff = true;
      setTimeout(() => (this.isShowDropoff = false), 2000);
    },
    viewOrderDetails() {
      var orderValue = parseInt(this.t.data.delivery.order_value);
      var deliveryFee = parseInt(this.t.data.fare.price);
      var total = orderValue + deliveryFee;
      var payment = this.translatePayment(this.t.data.delivery.payment_method);
      var txt1 = this.$t("delivery.payment-method");
      var txt2 = this.$t("price");
      var txt3 = this.$t("home.delivery");
      var txt4 = this.$t("total");
      var symbol = this.currencySymbol(this.t.business.country);
      this.$swal({
        imageUrl: this.t.data.delivery.receipt_pic,
        imageHeight: 400,
        html: `<div style='text-align:left'>
        <i>${txt1}: <strong>${payment}</strong></i><br>
        ${txt2}: ${symbol}${orderValue}<br>
        ${txt3}: ${symbol}${deliveryFee}<br>
        <strong>${txt4}: ${symbol}${total}</strong><br>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    getDrivers() {
      this.$store
        .dispatch("autocompleteDriverWorkflows", this.workflowID)
        .then((res) => {
          if (res.data) this.drivers = res.data;
          else this.drivers = [];
        })
        .catch((err) => console.error("autocompleteDrivers", err));
    },
    selectDriver(e) {
      this.dispatchTo = e.target.value;
      console.log("selected driver", this.dispatchTo, e);
    },
    dispatch() {
      if (!this.dispatchTo) {
        this.warningAlert("Please set driver for dispatch");
        return;
      }
      this.accept();
    },
    accept() {
      EventBus.$emit("FIT_MAP");
      this.editing = true;
      var loader = this.loadingDots();
      var obj = {};
      //   var obj = { driver_distance: this.distanceToPickupMeters }; // data object to append
      //   if (this.eta) obj.eta = parseInt(this.eta); //obj = { eta: parseInt(this.eta) };
      var driverID = null; // this.$store.state.user.id; // default you are driver
      if (this.dispatchTo) {
        driverID = this.dispatchTo; // otherwise dispatch
        obj.acknowledged = false;
      }
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.transaction.id,
          data: {
            workflow_id: this.workflowID,
            state: "confirmed",
            handled_by: driverID,
            data: obj, // data obj appends
          },
        })
        .then(() => this.$emit("update"))
        .catch((err) => {
          console.error("accept transaction error", err);
          this.warningAlert(this.$t("driver.another-driver-accepted"));
          this.$emit("update");
        })
        .finally(() => {
          loader.hide();
          this.editing = false;
        });
    },
    reject() {
      this.editing = true;
      var txt = this.$t("driver.reject-are-you-sure");
      this.$swal({
        // title: this.$t("driver.reject-are-you-sure"),
        // html: '<i class="fa fa-question fa-4x" />',
        html: `<div style='text-align:left'>
        <p style='font-size:1.3em; margin-bottom:12px'>
        <i class="far fa-times-circle"></i>&nbsp;Ignore the job</p>
        <p>${txt}</p></div>`,
        showCancelButton: true,
        cancelButtonText: this.$t("driver.yes-reject"),
        confirmButtonText: this.$t("no"),
      }).then((result) => {
        this.console("reject result", result);
        this.editing = false;
        if (result.dismiss === "cancel") {
          this.updateOrdersFleetDispatcher(); // this.$emit("update")
          var loader = this.loadingDots("hotpink");
          setTimeout(() => loader.hide(), 500);
          this.$store
            .dispatch("patchTransaction", {
              transactionID: this.transaction.id,
              data: { state: "rejected" },
            })
            .then((res) => console.log(res.data))
            .catch((err) => this.apiError(err));
          // .finally(() => loader.hide());
        }
      });
    },
    shareRideRequest() {
      if (!navigator.share) {
        this.warningAlert("Sharing not supported by this device!");
        return;
      }
      var msg = `📍${this.pickupName}
👉🏼${this.$t("driver.go-to-app-to-take")}`;
      navigator
        .share({ text: msg })
        .catch((err) => this.console("Error sharing", err));
    },
  },
};
</script>

<style scoped>
.subtitle {
  margin-bottom: 0;
  margin-left: 12px;
  margin-top: 12px;
}
.profile-pic {
  object-fit: cover;
  height: 80px;
  width: 80px;
  border-radius: 3px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  background-color: white;
}
.bottom-wrapper {
  z-index: 2;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: auto;
  min-height: 30%;
  /* height: 30%; */
  width: 100%;
  background-color: white;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.2);
  border-top: 6px solid rgba(34, 255, 0, 0.6);
}
.is-retry {
  border-top: 6px solid hotpink;
}
.media-left {
  margin-right: 4px;
}
/* .card .media {
  overflow: hidden;
} */
/* .cards {
  overflow: hidden;
  height: 25vh;
  overflow: scroll;
  overflow-x: hidden;
} */
a:active,
a:visited {
  color: blue;
}
.circle {
  border-radius: 50%;
  background-color: red;
  color: white;
  padding: 2px;
  width: 10px;
  height: 10px;
  opacity: 0.8;
}
.tag {
  padding: 0 6px;
}
div.card-content {
  padding: 14px;
}
.distance-message {
  position: relative;
  text-align: center;
  top: -60px;
  width: 100vw;
  height: 0px;
  opacity: 0.85;
}
.buttons {
  margin: 6px;
  margin-top: 16px;
  /* margin-bottom: 6px; */
}
/* .card.media {
  margin-bottom: 0px !important;
} */
.card .media:not(:last-child) {
  margin-bottom: 0px;
}
.share-btn {
  position: absolute;
  right: 10px;
  top: 8px;
  padding: 0 10px;
}
.pickup-dist {
  padding: 3px 7px;
}
.fa-user,
.fa-store-alt {
  width: 30px;
  text-align: center;
  color: grey;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
}
.user-tags .tag {
  margin-left: 4px;
}
.pax-cnt {
  margin-left: -4px;
  margin-right: 4px;
  font-size: 0.8em;
  font-weight: 550;
}
.fare {
  /* width: 80px; */
  padding: 4px;
  font-weight: 500;
  /* font-size: 1.25em; */
  /* background-color: #eee; */
  line-height: 36px;
  border-radius: 4px;
}
.fare span {
  vertical-align: middle;
  height: 100%;
}
.fare-wrapper {
  margin-left: 4px;
  margin-top: 6px;
  margin-bottom: 10px;
}
.scheduled {
  width: 100%;
  font-weight: 550;
  /* font-size: 1em; */
  margin-top: 10px;
  background-color: yellow;
}
.tukpay-logo {
  height: 22px;
  display: inline-block;
  position: relative;
  top: 6px;
  margin-left: 4px;
  /* filter: drop-shadow(1px 1px 1px white); */
}
.accept-btn {
  width: calc(60%);
}
.reject-btn {
  width: calc(40% - 16px);
}
.opaque {
  opacity: 0.7;
  background-color: red !important;
}
.order-no {
  text-align: center;
  display: inline-block;
  width: 80px;
  border-radius: 3px;
  border: 1.5px dotted grey;
  margin-right: 6px;
  font-weight: 550;
  background-color: lightcyan;
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
  box-shadow: 0 0 2px grey;
  font-size: 1.2em;
  line-height: 1.2em;
}
.shop-name {
  font-weight: 500;
  color: grey;
}
</style>

